export const LIST_LOAD_REQUEST = 'LIST_LOAD_REQUEST';
export const LIST_LOAD_SUCCESS = 'LIST_LOAD_SUCCESS';
export const LIST_LOAD_FAILURE = 'LIST_LOAD_FAILURE';
